import React from "react";
import { connect } from "react-redux";
import { Link } from "react-router-dom";
import { Nav, NavbarToggler, NavItem, Badge } from "reactstrap";
import ButtonLogout from "../Button/ButtonLogout";
import ToggleHelp from "../../components/Help/ToggleHelp";
import { GetTeacherInformation } from "../../actions/teacherQueries";
import {
  EnvironmentInfo,
  EnvironmentColor,
} from "../EnvironmentInfo/EnvironmentInfo";
import MaintenanceMessage from "../MaintenanceMessage/MaintenanceMessage";
import MobileLogout from "../MobileLogout/MobileLogout";
import { FormattedMessage } from "react-intl";
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome";
import { useSelector } from "react-redux";

function Header(props) {
  const { auth } = props;

  var sidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-hidden");
  };

  var mobileSidebarToggle = (e) => {
    e.preventDefault();
    document.body.classList.toggle("sidebar-mobile-show");
  };

  const teacherInfo =
    auth.auth.roles === "Teacher" ? GetTeacherInformation() : null;
  if (auth.auth.roles === "Teacher") {
    document.body.classList.remove("sidebar-hidden");
  } else {
    document.body.classList.add("sidebar-hidden");
  }

  const notifications = useSelector((state) => state.notificationsReducer);

  const showNotifications =
    auth.auth.roles === "Teacher" || auth.auth.roles === "Student";
  /*     if (teacherInfo != null && teacherInfo.isLoading) {
      return null;
    } */

  return (
    <header
      className="app-header navbar"
      id="main__navbar"
      style={EnvironmentColor()}
    >
      {auth.auth.roles === "Student" && (
        <NavbarToggler className="d-lg-none" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      <Link to="/" className="main__navbar-brand">
        <div className="navbar-brand a" style={EnvironmentColor()} />
      </Link>

      {auth.auth.roles === "Student" && (
        <NavbarToggler className="d-md-down-none" onClick={sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      {auth.auth.roles === "Teacher" && (
        <NavbarToggler className="d-lg-none" onClick={mobileSidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}
      {auth.auth.roles === "Teacher" && (
        <NavbarToggler className="d-md-down-none" onClick={sidebarToggle}>
          <span className="navbar-toggler-icon" />
        </NavbarToggler>
      )}

      <MaintenanceMessage />
      <EnvironmentInfo />
      {auth.auth.roles === "Teacher" &&
        teacherInfo !== null &&
        !teacherInfo.isLoading && (
          <Nav className="Header-Nav--Navgroup stroke">
            {teacherInfo.data.purchaser && (
              <>
                <NavItem className="Header-Nav-Item">
                  <Link to="/teacher/shop" className="Header-Nav-Item--link">
                    <FormattedMessage id="Shop" />
                  </Link>
                </NavItem>
                <NavItem className="Header-Nav-Item">
                  <Link
                    to="/teacher/invoicehistory"
                    className="Header-Nav-Item--link"
                  >
                    <FormattedMessage id="Navigation_Teacher_Invoice_History" />
                  </Link>
                </NavItem>
              </>
            )}
            <NavItem className="Header-Nav-Item">
              <Link to="/teacher/aboutUs" className="Header-Nav-Item--link">
                <FormattedMessage id="AboutUs" />
              </Link>
            </NavItem>
          </Nav>
        )}
      {showNotifications && (
        <Nav className="Header-Nav--Navgroup stroke">
          <Link
            to={
              auth.auth.roles === "Teacher"
                ? "/teacher/notifications"
                : "/student/notifications"
            }
            className="Header-Nav-Item--Notifications"
          >
            <FontAwesomeIcon icon="bell" color="#20A8DA" />
            {notifications.notifications.filter(
              (notif) => !notif.isSeenByMe && !notif.notice.isDeleted
            ).length > 0 && (
              <Badge
                className="mb-4 notifications-count-badge"
                style={{
                  borderRadius: "50%",
                  position: "relative",
                  top: "-.5rem",
                  paddingTop: "0.15rem",
                  color: "white",
                  border: "1px solid red",
                }}
              >
                <span>
                  {
                    notifications.notifications.filter(
                      (notif) => !notif.isSeenByMe && !notif.notice.isDeleted
                    ).length
                  }
                </span>
              </Badge>
            )}
          </Link>
        </Nav>
      )}
      <Nav className="ms-auto" id="main__navbar-nav" navbar>
        <ToggleHelp></ToggleHelp>
        <ButtonLogout />
      </Nav>

      <MobileLogout />
    </header>
  );
}

const mapStateToProps = (store) => {
  return {
    auth: store.auth,
  };
};

export default connect(mapStateToProps)(Header);
